import { BACKGROUND_IMAGE_MOBILE, BACKGROUND_IMAGE_DESKTOP, IMAGE_MOBILE, IMAGE_DESKTOP, ICON_FIELD, ASSET_MOBILE, ASSET_DESKTOP } from '../elements/assets'

export const CASE_STUDIES_CAROUSEL = `
...on caseStudiesCarousel_Entry {
  id
  typeHandle
  anchorId

  heading: headingAdvanced {
    html
  }
  description

  cards: caseStudiesCarousel {
    id
    title

    ${ ICON_FIELD }

    ${ IMAGE_MOBILE }
    ${ IMAGE_DESKTOP }

    imageText

    ${ BACKGROUND_IMAGE_MOBILE }
    ${ BACKGROUND_IMAGE_DESKTOP }

    tags {
      title
    }
    caseStudyHeading
    caseStudyText { html }

    ${ ASSET_MOBILE }
    ${ ASSET_DESKTOP }

  }
}
`